import Field from "../Field";
import CrossReferencedDHWField from "./CrossReferencedDHWField";
import CrossReferencedHeatingField from "../controller/CrossReferencedHeatingField";

export class CalculationPropertiesRowPressureField extends Field {
    get unit() {
        return 'bar'
    }
}

export class CalculationPropertiesRowDHWPressureField extends CrossReferencedDHWField {
    get unit() {
        return 'bar'
    }
}

export class CalculationPropertiesRowHeatingPressureField extends CrossReferencedHeatingField {
    get unit() {
        return 'bar'
    }
}